import { render, staticRenderFns } from "./BedchairtablePage.vue?vue&type=template&id=037cd7f6&scoped=true&"
import script from "./BedchairtablePage.vue?vue&type=script&lang=js&"
export * from "./BedchairtablePage.vue?vue&type=script&lang=js&"
import style0 from "./BedchairtablePage.vue?vue&type=style&index=0&id=037cd7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cd7f6",
  null
  
)

export default component.exports